module.exports = __webpack_public_path__ + "static/award-softchecker-d389c3284247ff9c86c5d70bc906d138.svg";